import Person from '@material-ui/icons/Person'
import UserAdd from './UserAdd'
import UserEdit from './UserEdit'
import UserList from './UserList'

const users = (permissions) => ({
  create: permissions.includes('create:users') ? UserAdd : undefined,
  edit: permissions.includes('update:users') ? UserEdit : undefined,
  icon: Person,
  list: UserList,
  name: 'users',
})

export default users
